<mat-card appearance="outlined" class="table-container" content>
  <div class="table-header">
    <span *ngIf="accountsDataSource.totalAccountsText$ | async as totalAccountsText">
      {{
        'ACTION_LISTS.ACTION_LISTS_ACCOUNTS.SHOWING_PAGESIZE_OF_TOTAL'
          | translate
            : {
                pageSize: (accountsDataSource.accounts$ | async)?.length,
                total: totalAccountsText
              }
      }}
    </span>
  </div>
  <mat-table #table matSort [dataSource]="accountsDataSource">
    <ng-container matColumnDef="name-address">
      <mat-header-cell *matHeaderCellDef class="name-address-column">
        {{ 'ACTION_LISTS.ACTION_LISTS_ACCOUNTS.ACCOUNT_NAME_AND_ADDRESS' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let account" class="name-address-column">
        <app-address-cell [accountGroupId]="account.accountGroupId"></app-address-cell>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="modified">
      <mat-header-cell *matHeaderCellDef class="modified-column">
        {{ 'ACTION_LISTS.ACTION_LISTS_ACCOUNTS.MODIFIED' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let account" class="modified-column">
        <div>{{ account.modified | glxyDate }}</div>
        <div>{{ account.modified | glxyDate : DateFormat.shortTime }}</div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef class="actions-column"></mat-header-cell>
      <mat-cell *matCellDef="let account" class="actions-column">
        <mat-icon [matMenuTriggerFor]="menu" class="kabob-menu">more_vert</mat-icon>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="removeAccount(account)">
            {{ 'ACTION_LISTS.ACTION_LISTS_ACCOUNTS.REMOVE_FROM_LIST' | translate }}
          </button>
        </mat-menu>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" matRipple></mat-row>
  </mat-table>
  <div class="table-footer">
    <mat-spinner *ngIf="loading$ | async; else loadMoreButton" [diameter]="30"></mat-spinner>
    <ng-template #loadMoreButton>
      <button mat-button class="load-more-button" *ngIf="hasMore$ | async" color="primary" (click)="loadNextPage()">
        {{ 'COMMON.ACTION_LABELS.LOAD_MORE' | translate }}
      </button>
    </ng-template>
  </div>
  <app-empty-table-placeholder
    *ngIf="(accountsDataSource.totalAccounts$ | async) === 0"
    [message]="'ACTION_LISTS.ACTION_LISTS_ACCOUNTS.NO_ACCOUNTS_IN_LIST' | translate"
    [showButton]="false"
  ></app-empty-table-placeholder>
</mat-card>
